module.exports = __webpack_public_path__ + "img/header-info.e10ec9f4.svg";